import React from "react";
import CertificateIcon from "../../assets/certificate.png";
import Shadow from "../../assets/shadows/4.png";
import Misc from "../../assets/misc/3.svg";

const Certificate = () => {
  return (
    <div className="relative md:mb-[150px] sm:mb-[125px] mb-[100px]">
      <div className="sm:max-w-container max-w-[90vw] mx-auto flex flex-col lg:gap-16 gap-0 lg:flex-row relative z-10">
        
        <div className="flex flex-col justify-between flex-shrink-0">
          <div className="flex flex-col lg:items-start items-center text-center">
            <p className="uppercase font-semibold text-sm text-warning mb-8">
              Certificates
            </p>
            <p className="font-semibold md:text-[40px] text-4xl leading-tight text-dark">
              Prizes
            </p>
          </div>
          <div className="w-fit mx-auto lg:-ml-10 -mt-28 lg:mt-0">
            <img src={CertificateIcon} />
          </div>
        </div>

        <div className="flex flex-col relative">
          <img
            src={Misc}
            className="absolute -translate-y-full -translate-x-1/2 rotate-[30deg] lg:rotate-0 lg:left-0 left-[50%]"
            alt=":( Not Found"
          />
          <div className="mx-auto w-full max-w-[712px] font-semibold lg:text-[3rem] md:text-4xl lg:leading-tight md:leading-snug leading-normal text-3xl text-dark mb-12 lg:mx-0 lg:text-left text-center">
            The winning team will{" "}
            <span className="text-warning">present their work</span> at
            one of the major upcoming UN BigData conferences and receive{" "}
            <span className="text-warning">rewards and certificates</span>.
          </div>
          <div className="relative bg-white rounded-3xl sm:text-xl text-base text-dark sm:px-11 px-8 py-8 lg:max-w-6xl">
            <p className="sm:mb-[18px] mb-4">
              There will also be special prizes {"(including tablets, iPads and others)"} for the 2nd and 3rd teams as well as the best all student and all female teams.
            </p>
            {/* <p>Other exciting prizes to be announced soon.</p> */}
          </div>
        </div>
      </div>
      <img src={Shadow} className="absolute sm:top-1/2 top-[20%] flex-shrink-0 -right-[50%] w-full -translate-y-1/2 -translate-x-1/2"/>
    </div>
  );
};

export default Certificate;
